import React from "react";

// A render error on one page used to unmount the whole app (white screen, every
// page gone until a reload). This catches it at the page level, shows what
// broke, and leaves the navigation working. Added 10/6 after the Loyalty page
// took the app down on a numeric-as-string formatting error.

interface Props { children: React.ReactNode }
interface State { error: Error | null }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error("Page crashed:", error, info.componentStack);
  }

  componentDidUpdate(prev: Props): void {
    // navigating to another page gives it a fresh start
    if (this.state.error && prev.children !== this.props.children) this.setState({ error: null });
  }

  render(): React.ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div className="p-6 max-w-2xl mx-auto">
        <div className="rounded-lg border p-5" style={{ borderColor: "var(--rbw-danger)", background: "var(--rbw-surface, #fff)" }}>
          <h2 className="text-lg font-bold mb-2" style={{ color: "var(--rbw-danger)" }}>This page hit an error</h2>
          <p className="text-sm mb-3">The rest of Karen still works. Use the menu to go somewhere else, or try again.</p>
          <pre className="text-xs whitespace-pre-wrap rounded p-3" style={{ background: "rgba(0,0,0,0.05)" }}>{String(this.state.error.message || this.state.error)}</pre>
          <button className="mt-3 px-4 py-2 rounded text-white text-sm font-medium" style={{ background: "var(--rbw-navy, #1f2a44)" }}
            onClick={() => this.setState({ error: null })}>
            Try again
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
